import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'src/app/components/form-components/shared.module';
import { AsstntSrchComponent } from './asstnt-srch/asstnt-srch.component';
import { AsstntSrchResultsComponent } from './asstnt-srch-results/asstnt-srch-results.component';
import { AsstntSrchActHomeComponent } from './asstnt-srch-act-home/asstnt-srch-act-home.component';
import { ConfirmAsstntComponent } from './confirm-asstnt/confirm-asstnt.component';
import { PiiShareAsstntComponent } from './pii-share-asstnt/pii-share-asstnt.component';
import { PostConfInstrAsstntComponent } from './post-conf-instr-asstnt/post-conf-instr-asstnt.component';
import { AstSrchRoutingModule } from './astSrch-routing.module';
import { NgxPaginationModule } from 'ngx-pagination';


@NgModule({
  declarations: [
    AsstntSrchComponent,
    AsstntSrchResultsComponent,
    AsstntSrchActHomeComponent,
    ConfirmAsstntComponent,
    PiiShareAsstntComponent,
    PostConfInstrAsstntComponent
  
  ],
  imports: [
    CommonModule,
    SharedModule,
    TranslateModule,
    AstSrchRoutingModule,
    NgxPaginationModule
  ],
  exports: [
    AsstntSrchComponent,
    AsstntSrchResultsComponent,
    AsstntSrchActHomeComponent,
    ConfirmAsstntComponent,
    PiiShareAsstntComponent,
    PostConfInstrAsstntComponent
    
  ],
  entryComponents: [
    
  ]
})
export class AstSrchModule { }
